import agentforce from './agentforce'
import authForm from './authForm'
import cart from './cart'
import chat from './chat'
import checkout from './checkout'
import clarity from './clarity'
import footer from './footer'
import hero from './hero'
import hotZone from './hotZone'
import languageSelector from './languageSelector'
import launchDarkly from './launchDarkly'
import linkedCard from './linkedCard'
import livechat from './livechat'
import loyaltyProgram from './loyaltyProgram'
import newsletterForm from './newsletterForm'
import optimizely from './optimizely'
import orderDetails from './orderDetails'
import page from './page'
import pdpPage from './pdpPage'
import plpPage from './plpPage'
import popUp from './popUp'
import product from './product'
import productFinder from './productFinder'
import promotion from './promotion'
import rewards from './rewards'
import saveForLater from './saveForLater'
import shopTheLook from './shopTheLook'
import socialNative from './socialNative'
import topNav from './topNav'
import upsell from './upsell'
import user from './user'
import video from './video'

export const events = {
  agentforce,
  authForm,
  cart,
  chat,
  checkout,
  clarity,
  footer,
  hero,
  hotZone,
  languageSelector,
  launchDarkly,
  linkedCard,
  livechat,
  loyaltyProgram,
  newsletterForm,
  optimizely,
  orderDetails,
  page,
  pdpPage,
  plpPage,
  popUp,
  product,
  productFinder,
  promotion,
  rewards,
  saveForLater,
  shopTheLook,
  socialNative,
  topNav,
  upsell,
  user,
  video
}

type ArgumentTypes<K> = K extends (...args: infer A) => any ? A : never

type Generator<Key extends string, Obj>
  = Key extends `${infer DomainName}.${infer EventName}`
    ? DomainName extends keyof Obj
      ? Generator<EventName, Obj[DomainName]>
      : never
    : Key extends keyof Obj
      ? Obj[Key]
      : never

type Paths<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? `${Key}` | `${Key}.${Paths<ObjectType[Key]>}`
    : `${Key}`
}[keyof ObjectType & (string | number)]

type FullPaths<Union, Result = ''> = Union extends [infer Key, ...infer Rest]
  ? Key extends `${string}.${string}`
    ? FullPaths<Rest, Result | Key>
    : FullPaths<Rest, Result>
  : Result

type Keys = FullPaths<[Paths<typeof events>]>

export declare function GTMPushMethod<K extends Keys>(
  event: K,
  ...payload: ArgumentTypes<Generator<K, typeof events>>
): void

export declare function GTMPushMethod<K extends Keys>(
  eventOrEvents: Array<{
    event: K
    payload: unknown
  }>
): void

export type GTMPush = typeof GTMPushMethod
